import React from "react";
import Button from "../../Button";
import Overlay from "../../Overlay";
import excalamation from "../../../assets/img/icons/table/excalamation.svg";

function EditSerieConfirmation({ type, onConfirm, onCancel, open = true }) {
  const handleCloseDialog = () => {
    onCancel();
  };

  const handleConfirm = async () => {
    await onConfirm();
  };
  return (
    <Overlay show={open} closable={true} onClick={handleCloseDialog}>
      <div className="delete-confirm-wrapper">
        <div className="delete-confirm-container">
          <div className="are-you-sure">
            <img src={excalamation} alt={"excalamation"} />
            <p>
              {type === "all"
                ? "Modifier toute une série d'écritures"
                : "Modifier une seule écriture"}
            </p>
          </div>

          <h1 className="popup-desc-content">
            {type === "all"
              ? "La modification que vous allez effectuer portera sur toutes les écritures de la série sélectionnée. Ok ?"
              : "L'écriture que vous avez allez modifier fait partie d'une série. Aprés modification sur cette écriture (quelle que soit la modification), l'écriture ne fera plus partie de la série. Ok ?"}
          </h1>

          <div className="delete-button-containers">
            <Button
              text={"Non"}
              onClick={handleCloseDialog}
              className={"action-button"}
            />
            <Button
              text={"Oui"}
              onClick={handleConfirm}
              className={"action-button agree-action-button"}
            />
          </div>
        </div>
      </div>
    </Overlay>
  );
}

export default EditSerieConfirmation;
